module.exports = __webpack_public_path__ + "img/support2.889b9123.png";